import React, { useState } from 'react';
import imgslide1 from '../components/img/slide1.png';
import imgslide2 from '../components/img/slide2.png';
import imgslide3 from '../components/img/slide3.png';
import imgslide5 from '../components/img/slide5.png';
import imgslide6 from '../components/img/slide6.png';
import imgslide7 from '../components/img/slide7.png';
import clicksound from './music/click.mp3';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const Tutorial = ({ show, handleClose }) => {
    const { t } = useTranslation();
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
      {
        img: imgslide1,
        ...t("modal_tutorial_bekel.0", { returnObjects: true }),
      },
      {
        img: imgslide2,
        ...t("modal_tutorial_bekel.1", { returnObjects: true }),
      },
      {
        img: imgslide3,
        ...t("modal_tutorial_bekel.2", { returnObjects: true }),
      },
      {
        img: imgslide5,
        ...t("modal_tutorial_bekel.3", { returnObjects: true }),
      },
      {
        img: imgslide6,
        ...t("modal_tutorial_bekel.4", { returnObjects: true }),
      },
      {
        img: imgslide7,
        ...t("modal_tutorial_bekel.5", { returnObjects: true }),
      },
    ];

    const handleSound = () => {
        const audio = new Audio(clicksound);
        audio.play();
    };

    const handleNext = () => {
        handleSound();
        if (currentSlide < slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            handleClose();
        }
    };

    const handleBack = () => {
        handleSound();
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    if (!show) return null;

    return (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 pointer-events-none"></div>
        <div className="fixed inset-0 flex items-center justify-center p-5 bg-black bg-opacity-50 z-50">
          <div className="bg-white lg:p-6 sm:p-4 md:p-4 sm:mb-10 rounded-3xl shadow-lg relative flex flex-row lg:w-1/2 sm:w-11/12 md:w-3/4 pointer-events-auto">
            {/* Tombol Close */}
            <button
              onClick={() => {
                handleSound();
                handleClose();
              }}
              className="close-button absolute top-2 right-2 px-3 py-3 text-gray-600 hover:text-gray-900 font-bold text-4xl"
            >
              &times;
            </button>

            <div className="flex-shrink-0 lg:w-64 lg:h-full sm:w-52 sm:h-full md:w-56 md:h-full">
              <img
                src={slides[currentSlide].img}
                alt={`Slide ${currentSlide + 1}`}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="lg:ml-4 mt-0 lg:text-left flex flex-col justify-between lg:p-2 sm:p-2 md:p-2">
              <p className=" sm:text-lg  md:text-lg lg:text-2xl font-bold">
                {slides[currentSlide].title}
              </p>
              <p className="  sm:text-xs  md:text-sm lg:text-base font-bold">
                {slides[currentSlide].tutorialtext}
              </p>
              <div className="flex justify-between mt-4">
                <button
                  onClick={handleBack}
                  className="PrevButton text-white bg-gray-800 px-4 py-2 rounded-full hover:bg-gray-700"
                  disabled={currentSlide === 0}
                >
                  {t("Kembali")}
                </button>
                <button
                  onClick={handleNext}
                  className="NextButton text-white bg-blue-800 px-4 py-2 rounded-full hover:bg-blue-700"
                >
                  {currentSlide < slides.length - 1 ? t("Next") : t("Tutup")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default Tutorial;
